import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { IOption, Select } from '@destination/components';
import { Type } from '@/models/Type';

export default function SelectModelType() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { t } = useTranslation(undefined, { keyPrefix: 'browse' });

  const functionalityType: IOption = {
    label: t('select_type.functionality'),
    value: Type.FUNCTIONALITY
  };

  const protocolType: IOption = {
    label: t('select_type.protocol'),
    value: Type.PROTOCOL
  };

  const deviceModelType: IOption = {
    label: t('select_type.device_model'),
    value: Type.DEVICE_MODEL
  };

  const modelTypes: IOption[] = [
    functionalityType,
    protocolType,
    deviceModelType
  ];

  const handleChange = (option: IOption) => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('type') === option.value) {
      params.delete('type');
      return setSearchParams(params);
    }

    params.set('type', option.value.toString());
    setSearchParams(params);
  };

  const selectedType =
    modelTypes.find(option => option.value === searchParams.get('type')) ||
    null;

  return (
    <Select
      placeholder={t('select_type.placeholder')}
      options={modelTypes}
      selected={selectedType}
      onChange={handleChange}
    />
  );
}
